// 头像图片
// 参数没有用，只是线上原来拼了参数的图片都被访问过了，有缓存了
export function getHeaderImage(img = '', size = 80) {
    if (!img) return ''
    if (img.indexOf('.svg') !== -1 || img.indexOf('data:image') !== -1) return img
    return `${img.replace('224_224', `${size}_${size}`)}?iopcmd=thumbnail&type=8&width=80&height=80`
}